import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const FlashIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.83 3L5.437 12.619C5.147 12.996 5.002 13.184 5 13.343C4.998 13.481 5.055 13.613 5.154 13.7C5.268 13.8 5.494 13.8 5.947 13.8H12L11.17 21L18.563 11.381C18.853 11.004 18.998 10.816 19 10.657C19.002 10.519 18.945 10.387 18.846 10.3C18.732 10.2 18.506 10.2 18.053 10.2H12L12.83 3Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

FlashIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(FlashIcon);
